import {
  Box,
  Table,
  TableContainer as TableContainerChakra,
  TableContainerProps,
} from "@chakra-ui/react";
import { useContext } from "react";

import { TableContext } from "../rana-table";

import { TABLE_ROW_HEIGHT } from "./table-row";

export function TableContainer({ children, ...rest }: TableContainerProps) {
  const { containerRef, isSkeleton } = useContext(TableContext);

  return (
    <Box position="relative">
      <TableContainerChakra
        as={isSkeleton ? Box : undefined}
        ref={containerRef}
        borderWidth="base"
        borderColor="brand.border"
        rounded="base"
        minH={`calc(${TABLE_ROW_HEIGHT} * 11)`}
        bg="brand.bg"
        {...rest}
      >
        <Table variant="unstyled" as={isSkeleton ? Box : undefined}>
          {children}
        </Table>
      </TableContainerChakra>
    </Box>
  );
}
